import React, { useEffect, useState } from 'react';
import { Container, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import config from '../../config';

function AdminMessages() {
  const history = useHistory();
  const [messages, setMessages] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      history.replace('/admin');
      return;
    }
    fetch(`${config.API_BASE}/admin/contact-messages`, {
      headers: { 'Authorization': token }
    })
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setMessages(data);
        } else {
          setError(data.error || 'Failed to fetch messages');
        }
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to fetch messages');
        setLoading(false);
      });
  }, [history]);

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    history.replace('/admin');
  };

  return (
    <Container maxWidth="md" style={{ marginTop: 48, background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(21,28,67,0.06)', padding: 32 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5">Contact Messages</Typography>
        <Button variant="outlined" color="secondary" onClick={handleLogout}>Logout</Button>
      </Box>
      {loading ? (
        <Typography>Loading...</Typography>
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : messages.length === 0 ? (
        <Typography>No messages found.</Typography>
      ) : (
        <TableContainer component={Paper} style={{ borderRadius: 12 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Message</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {messages.map((msg) => (
                <TableRow key={msg._id}>
                  <TableCell>{msg.name}</TableCell>
                  <TableCell>{msg.email}</TableCell>
                  <TableCell>{msg.message}</TableCell>
                  <TableCell>{msg.createdAt ? new Date(msg.createdAt).toLocaleString() : ''}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Container>
  );
}

export default AdminMessages; 